"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faAlarmExclamation_1 = require("@fortawesome/pro-solid-svg-icons/faAlarmExclamation");
const tags_1 = require("../../atoms/tags");
const typography_1 = require("../../shared/typography");
const react_i18next_1 = require("react-i18next");
const hooks_1 = require("../../shared/hooks");
const Header = ({ tagVariant, tagDate, onClick }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, hooks_1.useRWD)();
    const tagText = `${t(`measurement.overview.${tagVariant === "red" ? "lastMeasurementAt" : "nextMeasurementAt"}`)} ${tagDate}`;
    const onHeaderClick = (e) => {
        e.stopPropagation();
        onClick();
    };
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { onClick: onHeaderClick, "data-cy": "measurements-overview-header", children: t("measurement.overview.title") }, void 0), tagDate && ((0, jsx_runtime_1.jsxs)(tags_1.Tag, { variant: tagVariant, children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faAlarmExclamation_1.faAlarmExclamation, size: "xs" }, void 0), isMobile ? `${tagDate}` : tagText] }, void 0))] }, void 0));
};
exports.Header = Header;
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-right: ${({ theme }) => theme.spacings.xs};

  h2 {
    cursor: pointer;
    flex: 1;
    margin-bottom: 0;
  }

  span {
    margin: 0;
  }
`;
//# sourceMappingURL=Header.js.map